import { createMergeReducer } from '../utils/reducer'

type Features = 'useMFA' | 'useFaq' | 'useContactUs' | 'usePlayer' | 'useSixteenByNine' | 'useTermsAndFeedback' | 'isElcano'

export type FeatureToStatus = { [feature in Features]?: boolean }

export const reducer = createMergeReducer(
  t => t.features,
  {} as FeatureToStatus
)
